import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/[lang]/loyalty/Loyality.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2350165087/src/cloudix/src/app/[lang]/loyalty/style.css");
